import React from 'react';
// styles
import styles from './why-we-are-different.module.scss';

interface IProps {
  title: string;
  description?: string;
  tick_image: {
    filename_disk: string;
  };
  image: {
    filename_disk: string;
  };
  items: Array<{
    point: string;
  }>;
  background?: string;
}

const WhyWeAreDifferent: React.FC<IProps> = ({ title, items, image, tick_image, description, background = '' }) => {
  return (
    <section className={styles['section' + background]}>
      <img
        className={`lazyload ${styles.mainImage} ${styles.mobileImage}`}
        src={`${process.env.GATSBY_MEDIA_URL}${image.filename_disk}`}
        data-src={`${process.env.GATSBY_MEDIA_URL}${image.filename_disk}`}
      />
      <div className={styles.container}>
        <img
          className={`lazyload ${styles.mainImage} ${styles.desktopImage}`}
          src={`${process.env.GATSBY_MEDIA_URL}${image.filename_disk}`}
          data-src={`${process.env.GATSBY_MEDIA_URL}${image.filename_disk}`}
        />
        <div className={styles.pointsWrapper}>
          <h2>{title}</h2>
          {description && <span dangerouslySetInnerHTML={{ __html: description }}></span>}
          <div className={styles.listWrapper}>
            <ul>
              {items.map(item => (
                <li>
                  <img src={`${process.env.GATSBY_MEDIA_URL}${tick_image.filename_disk}`} />
                  {item.point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
export default WhyWeAreDifferent;
